import './ModulesDescriptionModal.css';

import { Button, Collapse, Icon, Modal, Spin } from 'antd';
import { bool, func, object, string } from 'prop-types';
import React, { PureComponent } from 'react';

import icons from '../../assets/images/icons/modules';
import ModuleStatus from './ModuleStatus';

const { Panel } = Collapse;

class ModulesDescriptionModal extends PureComponent {
  static propTypes = {
    modalVisible: bool.isRequired,
    activeModal: string,
    modalToggle: func.isRequired,
    modulesDescription: object,
    loading: bool.isRequired,
  };

  state = {
    activePanels: [],
    activeModal: this.props.activeModal,
  };

  componentDidUpdate = prevProps => {
    if (!this.props.modulesDescription && !this.props.loading) {
      this.props.fetchModulesDescription();
    }

    if (this.props.modalVisible !== prevProps.modalVisible) {
      this.setState({ activePanels: [], activeModal: this.props.activeModal });
    }
  };

  handleCollapsePanelChange = e => {
    if (e[0] === 'header') return;
    this.setState({ activePanels: e });
  };

  getTitle = type => {
    if (!this.props.modulesDescription) return '';
    switch (type) {
      case 'primary':
        return `Список действующих основных модулей`;
      case 'secondary':
        return `Список действующих дополнительных модулей`;
      case 'all':
        return `Список всех модулей`;
      case 'development':
        return `Список модулей в разработке`;
      default:
        return '';
    }
  };

  getModulesDescription = activeModal => {
    const { modulesDescription, modalVisible } = this.props;
    if (!modulesDescription || !modalVisible) return null;

    if (activeModal !== 'all')
      return Object.keys(modulesDescription[activeModal]).map(key => {
        return {
          moduleName: key,
          type: activeModal,
          ...modulesDescription[activeModal][key],
        };
      });

    const { primary, secondary, development } = modulesDescription;

    const modulesArr = [];

    Object.keys(primary).map(key =>
      modulesArr.push({
        moduleName: key,
        type: 'primary',
        ...primary[key],
      })
    );
    Object.keys(secondary)
      .filter(key => secondary[key].portion === 'none')
      .map(key =>
        modulesArr.push({
          moduleName: key,
          type: 'secondary',
          ...secondary[key],
        })
      );
    Object.keys(development).map(key =>
      modulesArr.push({
        moduleName: key,
        dev: true,
        ...development[key],
      })
    );

    return modulesArr;
  };

  render() {
    const { modalVisible, activeModal, modalToggle } = this.props;

    const modulesDescription = this.getModulesDescription(activeModal);

    return (
      <Modal
        className="rates-modules-desc-modal"
        width={700}
        title={this.getTitle(activeModal)}
        visible={modalVisible}
        footer={
          <div>
            {activeModal !== 'all' ? (
              <Button
                size="large"
                onClick={() => {
                  if (activeModal !== 'development') {
                    this.setState({ activeModal });
                  }

                  modalToggle(
                    true,
                    activeModal === 'development' ? this.state.activeModal : 'development'
                  );
                }}
              >
                {this.getTitle(
                  activeModal === 'development' ? this.state.activeModal : 'development'
                )}
              </Button>
            ) : null}
            <Button type="primary" size="large" onClick={() => modalToggle(false)}>
              Закрыть
            </Button>
          </div>
        }
        destroyOnClose
        onCancel={() => modalToggle(false)}
      >
        {modulesDescription ? (
          <Collapse
            bordered={false}
            activeKey={this.state.activePanels}
            onChange={this.handleCollapsePanelChange}
            destroyInactivePanel
          >
            {activeModal === 'all' && (
              <Panel
                className="rates-modules-desc-collapse-item rates-modules-desc-collapse-header"
                header={
                  <div className="rates-modules-desc-collapse-item-header-cont">
                    <div>Название</div>
                    <div>Статус</div>
                    <div>Тип</div>
                    <div>Описание</div>
                  </div>
                }
                key="header"
                showArrow={false}
              />
            )}
            {modulesDescription.map((mod, index) => {
              const isActive = this.state.activePanels.includes(index.toString());
              return (
                <Panel
                  className={`${
                    isActive
                      ? 'rates-modules-desc-collapse-item rates-modules-desc-collapse-item-active'
                      : 'rates-modules-desc-collapse-item'
                  }`}
                  header={
                    <div className="rates-modules-desc-collapse-item-header">
                      <div className="rates-modules-desc-collapse-item-header-module">
                        <div className="rates-modules-col1">
                          <img
                            alt=""
                            src={icons[mod.moduleName] || icons.defaultIcon}
                            className="rates-modules-desc-collapse-item-header-module-icon"
                          />
                          <span>
                            {mod.title_ru}
                            {activeModal !== 'all' &&
                            mod.type === 'secondary' &&
                            mod.portion !== 'none' ? (
                              <span>{` (Функция модуля ${
                                this.props.modulesDescription.primary[mod.portion].title_ru
                              })`}</span>
                            ) : (
                              ''
                            )}
                          </span>

                          {mod.hasOwnProperty('status') && <ModuleStatus status={mod.status} />}
                        </div>

                        {activeModal === 'all' && (
                          <>
                            <div className="rates-modules-col2">
                              {mod.dev ? 'в разработке' : 'готов'}
                            </div>
                            <div className="rates-modules-col3">
                              {mod.type === 'primary' ? 'основной модуль' : 'дополнительный модуль'}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="rates-modules-desc-collapse-item-header-arrow-wrap">
                        читать описание
                        <Icon
                          className="rates-modules-desc-collapse-item-header-arrow"
                          type={isActive ? 'up' : 'down'}
                        />
                      </div>
                    </div>
                  }
                  key={mod.moduleName}
                  showArrow={false}
                >
                  <span>{mod.desc}</span>
                  {mod.hasOwnProperty('video') && (
                    <div className="ssmm-video-wrap">
                      <iframe
                        src={`https://www.youtube.com/embed/${mod.video}`}
                        frameBorder="0"
                        allowFullScreen
                        title={mod.title_ru}
                      />
                    </div>
                  )}
                </Panel>
              );
            })}
          </Collapse>
        ) : (
          <div className="modules-desc-modal-spin-cont">
            <Spin size="large" />
          </div>
        )}
      </Modal>
    );
  }
}

export default ModulesDescriptionModal;
